import React, { Component } from "react";
import { SideBar, NavBar } from "../../components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import moment from "moment";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
} from "reactstrap";

class Template extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.notificar = this.notificar.bind(this);
    this.handleClickVisualizar = this.handleClickVisualizar.bind(this);
    this.toggleModalDeletar = this.toggleModalDeletar.bind(this);
    this.handleClickDeletar = this.handleClickDeletar.bind(this);
    this.handleConfirmDeletar = this.handleConfirmDeletar.bind(this);
    this.toggleModalCadastro = this.toggleModalCadastro.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleClickCadastrar = this.handleClickCadastrar.bind(this);
    this.handleClickResponder = this.handleClickResponder.bind(this);

    this.state = {
      formularios: [],
      modalDeletar: false,
      idTemplateDeletar: null,
      tema: props.getTema(),

      modalCadastro: false,
      nome: "",
      descricao: "",

      templates: [],
    };
  }

  async componentDidMount() {
    this.load();
  }
  async load() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/templates`, this.props.parameters())
      .then((response) => {
        this.setState({ templates: response.data.templates });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          this.notificar("warning", error.response.data.erro);
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleClickVisualizar(id) {
    this.props.history.push(`/templates-novo?id=${id}`);
  }

  handleClickResponder(template) {
    const substituicoes = {
      //nome: "Felipe",
      nome: null,
      idade: 25,
    };

    template.html = template.html.replace(
      /\$\{([^}]+)\}/g,
      (match, variavel) => substituicoes[variavel]
    );

    localStorage.setItem("html", template.html);
    localStorage.setItem("tituloTemplate", template.titulo);
    //return this.props.history.push(`/templates-impressao`);
    window.open("/templates-impressao", "_blank");
  }

  toggleModalDeletar() {
    this.setState({ modalDeletar: !this.state.modalDeletar });
  }

  handleClickDeletar(id) {
    this.setState({ idTemplateDeletar: id }, () => {
      this.toggleModalDeletar();
    });
  }

  async handleConfirmDeletar() {
    let id = this.state.idTemplateDeletar;

    await axios
      .delete(
        `${this.props.getBaseUrlApi()}/templates/${id}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState({ idTemplateDeletar: null }, async () => {
          this.toggleModalDeletar();
          await this.load();
          this.notificar("success", "Template deletado com sucesso!");
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          this.notificar("warning", error.response.data.erro);
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  toggleModalCadastro() {
    this.setState({ modalCadastro: !this.state.modalCadastro });
  }

  handleChangeInput(e, tipo) {
    this.setState({ [tipo]: e.target.value });
  }

  async handleClickCadastrar() {
    let nome = this.state.nome;

    if (nome === "") {
      this.notificar("warning", "Nome do template é obrigatório!");
      return false;
    }

    localStorage.setItem("nomeTemplate", nome);

    setTimeout(() => {
      this.props.history.push(`/templates-novo`);
      //this.props.history.push(`/templates-novo?id=${id}`);
    }, 1000);
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="wrapper">
          <SideBar itemActive="templates" />
          <div className="main-panel">
            <NavBar title="Templates" />

            <div className="content">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{ position: "relative" }}
                    >
                      <h4 className="card-title"> Lista de Templates</h4>
                      <div className="content-btn-novo-item">
                        {" "}
                        <button
                          className="btn btn-success"
                          onClick={() => {
                            this.toggleModalCadastro();
                          }}
                        >
                          Novo Template
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead
                            className="text-primary"
                            ref={(node) => {
                              if (node) {
                                node.style.setProperty(
                                  "color",
                                  this.state.tema.textoPrincipal,
                                  "important"
                                );
                              }
                            }}
                          >
                            <th>ID</th>
                            <th>Título</th>
                            <th className="text-center">Data Cadastro</th>
                            <th className="text-center">Ações</th>
                          </thead>
                          <tbody>
                            {this.state.templates.length > 0 &&
                              this.state.templates.map((template, key) => (
                                <tr key={key}>
                                  <td>
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(template.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {template.id}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(template.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {template.titulo}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span
                                      onClick={() =>
                                        this.handleClickVisualizar(template.id)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {moment(template.dataCadastro).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <div className="d-flex justifyContentCenter">
                                      <div
                                        style={{ margin: "0 3px" }}
                                        className="text-center"
                                      >
                                        <button
                                          className="btn btn-primary btn-round"
                                          onClick={() =>
                                            this.handleClickVisualizar(
                                              template.id
                                            )
                                          }
                                          id={`tooltip-editar-convenios-${template.id}`}
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`tooltip-editar-convenios-${template.id}`}
                                        >
                                          Editar
                                        </UncontrolledTooltip>
                                      </div>


                                      <div
                                        style={{ margin: "0 3px" }}
                                        className="text-center"
                                      >
                                        <button
                                          className="btn btn-warning btn-round"
                                          onClick={() => {
                                            this.props.history.push(
                                              `/templates-lista-resposta?id=${template.id}`
                                            );
                                          }}
                                          id={`tooltip-visualizar-convenios33-${template.id}`}
                                          style={{ color: "white" }}
                                        >
                                          <i className="fa fa-eye"></i>
                                        </button>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`tooltip-visualizar-convenios33-${template.id}`}
                                        >
                                          Visualizar Respostas
                                        </UncontrolledTooltip>
                                      </div>



                                      <div style={{ margin: "0 3px" }}>
                                        <button
                                          className="btn btn-danger btn-round"
                                          onClick={() =>
                                            this.handleClickDeletar(template.id)
                                          }
                                          id={`tooltip-deletar-convenios-${template.id}`}
                                        >
                                          <i className="fa fa-times"></i>
                                        </button>
                                        <UncontrolledTooltip
                                          placement="top"
                                          target={`tooltip-deletar-convenios-${template.id}`}
                                        >
                                          Deletar
                                        </UncontrolledTooltip>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.modalDeletar}
          toggle={this.toggleModalDeletar}
        >
          <ModalHeader toggle={this.toggleModalDeletar}>
            Deletar Template
          </ModalHeader>
          <ModalBody>Tem certeza que deseja deletar este template?</ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggleModalDeletar}
            >
              Não
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleConfirmDeletar}
            >
              Sim
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.modalCadastro}
          toggle={this.toggleModalCadastro}
        >
          <ModalHeader toggle={this.toggleModalCadastro}>
            Cadastrar Template
          </ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label>Nome</label>
              <input
                type="text"
                className="form-control"
                value={this.state.nome}
                onChange={(e) => {
                  this.handleChangeInput(e, "nome");
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggleModalCadastro}
            >
              Cancelar
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleClickCadastrar}
            >
              Próximo
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Template;
